export default __webpack_public_path__ + "static/media/a008-5.8fa51f7c.svg";